import React from "react";
import Link from "next/link";

import { PdfPhoneClick } from "@/components/community/PhoneReveal";

const AskQuestionHelp = () => {
    return (
        <div className="space-y-4">
            <h2 className="text-xl font-semibold">Get in Touch</h2>
            <p>We're here to help! Choose the best way to get in touch with us:</p>
            <div className="grid gap-4">
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-medium">Email Us</h3>
                    <p className="text-gray-800 mt-1">
                        Send us an email at{" "}
                        <a
                            href="mailto:community@purpledoorfinders.com"
                            className="text-primary-600 hover:text-primary-800 underline font-bold"
                        >
                            community@purpledoorfinders.com
                        </a>
                    </p>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-medium">Need Advice?</h3>
                    <p className="text-gray-800 mt-1">
                        Visit our{" "}
                        <Link
                            href="/contact-us"
                            className="text-primary-600 hover:text-primary-800 underline font-bold"
                        >
                            contact page
                        </Link>{" "}
                        and an advisor will contact you.
                    </p>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-medium">Call Us</h3>
                    <p className="text-gray-800 mt-1">
                        Reach us at{" "}
                        <a
                            href="tel:6127877533"
                            className="text-primary-600 hover:text-primary-800 font-bold"
                            onClick={PdfPhoneClick}
                        >
                            (612) PURPLE-3
                        </a>{" "}
                        or{" "}
                        <a
                            href="tel:6127877533"
                            className="text-primary-600 hover:text-primary-800 font-bold"
                            onClick={PdfPhoneClick}
                        >
                            (612) 787-7533
                        </a>
                    </p>
                </div>
            </div>
            <p className="text-sm text-gray-500 mt-4">
                Our team is available during business hours to assist you.
            </p>
        </div>
    );
};

export default AskQuestionHelp;
